import { render, staticRenderFns } from "./how-to-apply.vue?vue&type=template&id=0a564310"
import script from "./how-to-apply.vue?vue&type=script&lang=js"
export * from "./how-to-apply.vue?vue&type=script&lang=js"
import style0 from "./how-to-apply.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports